module.exports = __webpack_public_path__ + "img/menu.a641da88.svg";